__turbopack_context__.v({
  "content": "CarGallery-module-scss-module__i8sseq__content",
  "divider": "CarGallery-module-scss-module__i8sseq__divider",
  "header": "CarGallery-module-scss-module__i8sseq__header",
  "item": "CarGallery-module-scss-module__i8sseq__item",
  "itemDescription": "CarGallery-module-scss-module__i8sseq__itemDescription",
  "itemIcon": "CarGallery-module-scss-module__i8sseq__itemIcon",
  "itemImage": "CarGallery-module-scss-module__i8sseq__itemImage",
  "mdDown": "CarGallery-module-scss-module__i8sseq__mdDown",
  "mdUp": "CarGallery-module-scss-module__i8sseq__mdUp",
  "noImperfection": "CarGallery-module-scss-module__i8sseq__noImperfection",
  "root": "CarGallery-module-scss-module__i8sseq__root",
  "triggerGallery": "CarGallery-module-scss-module__i8sseq__triggerGallery",
  "triggerImperfection": "CarGallery-module-scss-module__i8sseq__triggerImperfection",
  "triggerInterior": "CarGallery-module-scss-module__i8sseq__triggerInterior",
});
